import { FormatMoneyToDisplay } from '../../helper/currency-helper';
import { RecentEarningAndLossActivityGroup } from '../../models/dashboard';

const RecentEarningAndLossCard = ({ data }: PropsType) => {
  return (
    <div className="col-span-full xl:col-span-6 bg-white  shadow-lg rounded-sm border border-slate-200 ">
      <header className="px-5 py-4 border-b border-slate-100 ">
        <h2 className="font-semibold text-slate-800 ">Recent Earning/Loss</h2>
      </header>
      <div className="p-3">
        {/* Card content */}
        {/* Group Name */}
        {data.map((activityGroup) => (
          <div key={activityGroup.groupName}>
            <header className="text-xs uppercase text-slate-400 bg-slate-50 rounded-sm font-semibold p-2">
              {activityGroup.groupName}
            </header>
            <ul className="my-1">
              {/* Item */}
              {activityGroup.activities.map((activity) => (
                <li key={activity.description} className="flex px-2">
                  {activity.amount >= 0 ? (
                    <div className="w-9 h-9 rounded-full shrink-0 bg-emerald-500 my-2 mr-3">
                      <svg
                        className="w-9 h-9 fill-current text-emerald-50"
                        viewBox="0 0 36 36"
                      >
                        <path d="M18.3 11.3l-1.4 1.4 4.3 4.3H11v2h10.2l-4.3 4.3 1.4 1.4L25 18z" />
                      </svg>
                    </div>
                  ) : (
                    <div className="w-9 h-9 rounded-full shrink-0 bg-rose-500 my-2 mr-3">
                      <svg
                        className="w-9 h-9 fill-current text-rose-50"
                        viewBox="0 0 36 36"
                      >
                        <path d="M17.7 24.7l1.4-1.4-4.3-4.3H25v-2H14.8l4.3-4.3-1.4-1.4L11 18z" />
                      </svg>
                    </div>
                  )}

                  <div className="grow flex items-center border-b border-slate-100 text-sm py-2">
                    <div className="grow flex justify-between">
                      <div className="self-center">
                        {activity.description}
                        <a
                          className="font-medium text-slate-800 hover:text-slate-900"
                          href="#0"
                        >
                          {activity.stock}
                        </a>
                        {' .'}
                      </div>
                      <div className="shrink-0 self-start ml-2">
                        <span
                          className={`font-medium ${
                            activity.amount >= 0
                              ? ' text-emerald-500'
                              : ' text-slate-800'
                          }`}
                        >
                          {activity.amount >= 0 ? '+' : '-'}
                          {FormatMoneyToDisplay(activity.amount)}
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

type PropsType = {
  data: RecentEarningAndLossActivityGroup[];
};

export default RecentEarningAndLossCard;
